
<div>
  <flex-align 
    v-if="isGridBuilder && selected.parent().name == 'GridItemWrapper'" 
    :mode="mode"
    :disable-alignment="hideFlexAlignment"
    :disable-constrain="hideFlexAlignment"
  ></flex-align>

  <cvt-collapse
    :accordion="true"
    :theme="mode === 'LIGHT' ? 'light' : 'dark'"
    :prepend-chevron="prependChevron"
  >
    <cvt-collapse-item
      :title="$t('elements.properties.spacing.label')"
      name="spacing"
      :initial-active="true"
      :special-style="isSpecialStyle"
    >
      <spacing-ctrl />
    </cvt-collapse-item>
  </cvt-collapse>
</div>
